// Texte par cours, indexé par les slugs de app/data/courses.ts.
const fr = {
  badgeNew: "Nouveau",

  ai: {
    title: "IA et apprentissage automatique",
    short:
      "Créez des applications intelligentes, des bases de l'apprentissage automatique aux LLMs et aux AI agents.",
    long: "Commencez par Python et la manipulation des données sur lesquels repose le domaine, puis parcourez les fondements de l'apprentissage automatique : comment un modèle apprend à partir de données, pourquoi il surapprend, et comment distinguer un bon résultat d'un simple coup de chance. De là, vous passez aux réseaux de neurones et à l'apprentissage profond, puis aux outils qui transforment le secteur en ce moment même : les grands modèles de langage, le prompt engineering, la recherche d'information et les AI agents qui appellent de vrais outils. Vous terminez en construisant et en déployant votre propre application. Aucune connaissance mathématique au-delà du secondaire n'est requise, et chaque séance est pratique, avec un instructeur à vos côtés.",
    level: "Débutant à avancé",
    duration: "10 à 14 semaines",
    topics: [
      "Python pour l'IA et les données",
      "Bases de l'apprentissage automatique",
      "Réseaux de neurones et apprentissage profond",
      "Grands modèles de langage (LLMs)",
      "Prompt engineering",
      "Créer des AI agents et des applications",
    ],
  },

  algorithms: {
    title: "Algorithmes",
    short:
      "Concevez et implémentez des algorithmes pour résoudre efficacement des problèmes complexes.",
    long: "Apprenez à raisonner sur ce que coûte un programme avant même de l'exécuter. Le cours débute par le tri, la recherche et la notation Big-O, puis progresse vers la récursivité, le retour sur trace, la programmation dynamique, les méthodes gloutonnes et la théorie des graphes. Chaque sujet s'apprend en écrivant l'algorithme vous-même, puis en le cassant, afin de comprendre où il échoue et pourquoi l'implémentation de la bibliothèque standard a la forme qu'elle a. C'est le cours qui rend les entretiens techniques abordables, et celui qui distingue ceux qui savent écrire du code de ceux qui savent dire si ce code tiendra sous la charge.",
    level: "Débutant à avancé",
    duration: "8 à 12 semaines",
    topics: [
      "Tri et recherche",
      "Complexité et Big-O",
      "Récursivité et retour sur trace",
      "Programmation dynamique",
      "Théorie des graphes",
      "Algorithmes gloutons",
    ],
  },

  programming: {
    title: "Programmation fondamentale",
    short:
      "Bâtissez des bases solides en code, en résolution de problèmes et en code propre.",
    long: "Le point de départ si vous n'avez jamais écrit une ligne de code. Vous commencez par les variables, les types, les structures de contrôle et les boucles, puis passez aux fonctions, à la portée, et à la structuration d'un programme pour qu'il reste lisible à mesure qu'il grandit. En chemin, vous abordez la programmation orientée objet, la gestion des erreurs et les habitudes qui séparent un code qui se contente de fonctionner d'un code qu'une autre personne peut maintenir. L'accent porte tout du long sur la résolution de problèmes plutôt que sur la mémorisation de la syntaxe : à la fin, vous savez prendre un problème énoncé en langage courant et le transformer vous-même en programme fonctionnel.",
    level: "Débutant",
    duration: "6 à 10 semaines",
    topics: [
      "Variables et types de données",
      "Structures de contrôle et boucles",
      "Fonctions et portée",
      "Programmation orientée objet",
      "Gestion des erreurs",
      "Bases du code propre",
    ],
  },

  architecture: {
    title: "Conception et architecture logicielle",
    short: "Les principes des systèmes logiciels évolutifs et maintenables.",
    long: "Pour les développeurs qui savent déjà construire des fonctionnalités et veulent maintenant concevoir des systèmes. Le cours couvre les principes SOLID et les patrons de conception qui méritent d'être connus, puis aborde la conception de systèmes à proprement parler : comment décomposer un domaine, où tracer les frontières entre services, quand les microservices aident et quand ils constituent une erreur coûteuse. Vous travaillez l'évolutivité, le cache, la performance et les modes de défaillance sur des architectures réelles, et vous vous exercez à rédiger les documents techniques qui font approuver une conception. Attendez-vous à passer autant de temps à défendre vos décisions qu'à les prendre.",
    level: "Intermédiaire à avancé",
    duration: "8 à 12 semaines",
    topics: [
      "Principes SOLID",
      "Patrons de conception",
      "Conception de systèmes",
      "Évolutivité et performance",
      "Microservices",
      "Documentation technique",
    ],
  },

  web: {
    title: "Développement web",
    short: "Créez des applications web modernes, du front-end au back-end.",
    long: "Construisez des applications web, du navigateur jusqu'à la base de données. Vous commencez par le HTML sémantique et la mise en page moderne en CSS, puis le JavaScript pour de vrai plutôt que comme une collection d'extraits, puis React et la façon dont un arbre de composants s'affiche réellement. La seconde moitié couvre Node.js, la conception d'une API, le dialogue avec une base de données, l'authentification et le déploiement du résultat pour que d'autres puissent s'en servir. Vous repartez avec une application full-stack que vous avez construite vous-même, et une compréhension de ce qui se passe entre la saisie d'une URL et l'affichage d'une page.",
    level: "Débutant à avancé",
    duration: "10 à 14 semaines",
    topics: [
      "HTML et CSS",
      "JavaScript",
      "React",
      "Node.js et API",
      "Bases de données",
      "Déploiement",
    ],
  },

  mobile: {
    title: "Développement mobile",
    short:
      "Publiez des applications pour iOS et Android, natives et multiplateformes.",
    long: "Publiez des applications sur les deux grandes plateformes mobiles. Vous travaillez d'abord en natif, avec Swift sur iOS et Kotlin sur Android, afin de comprendre les conventions de chaque plateforme au lieu de les combattre à travers une abstraction. Vous construisez ensuite la même application en multiplateforme avec Flutter et React Native, et vous voyez précisément ce que chaque approche vous coûte. Le cours couvre la gestion de l'état, le stockage local, l'usage des API de l'appareil, et les parties que personne n'enseigne : la validation sur les stores, la gestion des versions, et la publication d'une mise à jour sans casser l'expérience de ceux qui utilisent déjà l'application.",
    level: "Intermédiaire",
    duration: "10 à 14 semaines",
    topics: [
      "Swift (iOS)",
      "Kotlin (Android)",
      "Flutter",
      "React Native",
      "État et stockage",
      "Publication sur les stores",
    ],
  },

  server: {
    title: "Développement de bases de données et de serveurs",
    short:
      "Concevez et exploitez des bases de données, des API et des déploiements.",
    long: "Tout ce qui se passe après le départ de la requête du navigateur. Vous apprenez à modéliser correctement des données en SQL, à savoir quand un stockage documentaire ou clé-valeur est la meilleure réponse, et à lire un plan d'exécution quand quelque chose est lent. Le cours aborde ensuite la programmation côté serveur, la conception d'API REST et GraphQL, l'authentification et les erreurs de sécurité qui font les gros titres, puis le cache et les files d'attente en arrière-plan quand une seule requête en fait trop. Il se termine par le déploiement, la supervision et le côté opérationnel qui consiste à maintenir un service en marche une fois que de vrais utilisateurs en dépendent.",
    level: "Intermédiaire",
    duration: "8 à 12 semaines",
    topics: [
      "SQL et NoSQL",
      "Programmation côté serveur",
      "API REST et GraphQL",
      "Authentification et sécurité",
      "Cache et files d'attente",
      "Déploiement et DevOps",
    ],
  },

  career: {
    title: "CV et recherche d'emploi",
    short:
      "Rédigez un CV qui décroche des entretiens et menez une recherche d'emploi qui aboutit à une offre.",
    long: "Se faire embaucher est une compétence à part entière, distincte de la capacité à faire le travail. Le cours commence par le fonctionnement réel du recrutement : qui lit votre CV, pendant combien de temps, et ce que les logiciels de tri écartent avant qu'un humain ne voie quoi que ce soit. Vous réécrivez votre CV et vos profils LinkedIn et GitHub en fonction de cette réalité, construisez un portfolio qui prouve ce que vous avancez, et apprenez à trouver des offres au-delà des sites d'emploi que tout le monde actualise. Vous travaillez ensuite le reste du parcours : candidatures, entretiens avec des simulations et des retours francs, et négociation d'une offre sans vous sous-estimer. Les supports couvrent le marché allemand et européen ainsi que les candidatures à l'international.",
    level: "Tous niveaux",
    duration: "4 à 6 semaines",
    topics: [
      "Rédaction et structure du CV",
      "Profils LinkedIn et GitHub",
      "Construire un portfolio",
      "Trouver des offres et postuler",
      "Entraînement aux entretiens",
      "Négociation salariale",
    ],
  },
};

export default fr;
